
export enum StatisticsGranularity {
  Minute = 1,
  Hour = 2,
  Day = 3,
  Month = 4
}
